import { Country } from 'library/ts/model/enums/geo/Country';
import { Cookies } from 'library/ts/utilities/Cookies';
import { LOGGER_QUERY_PARAMS } from 'library/ts/utilities/logger/LogServiceConstants';
export class RuntimeVO {
    #cookieName;
    #cookies;
    #debugCookie;
    #utils;
    #app_name;
    #project;
    constructor(cookieName, app_name) {
        this.#cookieName = cookieName;
        this.#app_name = app_name;
        this.#project = window.PlayerServicesProjectInfo;
        this.#utils = window?.PARA?.PlayerServices?.Utilities;
        this.#cookies = Cookies.getInstance();
        this.#debugCookie = JSON.parse(this.#cookies.getItem(this.#cookieName));
    }
    get utils() {
        return this.#utils;
    }
    get app() {
        const appURL = () => {
            const scripts = document.getElementsByTagName('script');
            for (let i = 0; i < scripts.length; i++) {
                if (this.utils.String.hasSubstring(scripts[i].src, [this.#project.app_output_file[this.#app_name].js.min.value])) {
                    return scripts[i].src;
                }
            }
            return undefined;
        };
        const url = appURL();
        const parsed = this.utils.URL.parser(url);
        const ssl = parsed.protocol.indexOf('https') > -1;
        const root = url.split(this.#project.app_output_file[this.#app_name].js.min.value)[0];
        return {
            url: url,
            root: root,
            parsed: parsed,
            ssl: ssl
        };
    }
    get top() {
        const top = this.utils.URL.getTopReferrer();
        const parsed = this.utils.URL.parser(top);
        const ssl = parsed.protocol.indexOf('https') > -1;
        let country = Country.US;
        if (this.utils.URL.isPARA())
            country = this.utils.URL.countryFromURL();
        return {
            url: top,
            parsed: parsed,
            ssl: ssl,
            country: country
        };
    }
    get url() {
        const appURL = () => {
            const scripts = document.getElementsByTagName('script');
            for (let i = 0; i < scripts.length; i++) {
                if (this.utils.String.hasSubstring(scripts[i].src, [this.#project.app_output_file[this.#app_name].js.min.value])) {
                    return scripts[i].src;
                }
            }
            return undefined;
        };
        const getRootURL = () => {
            const splitURL = appURL().split(this.#project.app_output_dir[this.#app_name].value);
            if (this.utils.Type.isArray(splitURL) && !this.utils.Type.isEmpty(splitURL)) {
                return splitURL[0];
            }
            return '';
        };
        return {
            root: getRootURL(),
            app: appURL()
        };
    }
    get debug() {
        const topURL = this.top.url;
        const debugQueryParams = [
            +this.utils.URL.getQueryField(LOGGER_QUERY_PARAMS.DEBUG_SMART_TAG, topURL),
            +this.utils.URL.getQueryField(LOGGER_QUERY_PARAMS.DEBUG, topURL)
        ];
        const validLogLevel = (logLevel) => {
            return !!logLevel && !this.utils.Type.isEmpty(logLevel) && this.utils.Type.isNumber(+logLevel);
        };
        const findValidLogLevel = (logLevels) => {
            for (let i = 0, l = logLevels.length; i < l; ++i) {
                if (validLogLevel(logLevels[i])) {
                    return logLevels[i];
                }
            }
        };
        let logLevel = findValidLogLevel(debugQueryParams);
        if (!logLevel)
            logLevel = 0;
        const output = {
            cacheBust: this.utils.Convert.stringToBoolean(this.utils.URL.getQueryField('cacheBust', topURL), false),
            logLevel: logLevel,
            on: !!logLevel,
            player: this.utils.Convert.stringToBoolean(this.utils.URL.getQueryField('debugPlayer', topURL), false),
            lowLevel: this.utils.Convert.stringToBoolean(this.utils.URL.getQueryField('debugLowLevel', topURL), false),
            debugError: this.utils.URL.getQueryField('debugError', topURL)
        };
        if (!this.utils.Type.isEmpty(this.#debugCookie)) {
            let cookieLogLevel = findValidLogLevel([
                +this.#debugCookie[LOGGER_QUERY_PARAMS.DEBUG_SMART_TAG],
                +this.#debugCookie[LOGGER_QUERY_PARAMS.DEBUG]
            ]);
            if (!this.utils.Type.isEmpty(cookieLogLevel)) {
                if (this.utils.Type.isNumber(+cookieLogLevel)) {
                    cookieLogLevel = +cookieLogLevel;
                }
                else {
                    cookieLogLevel = 1;
                }
            }
            else {
                cookieLogLevel = 0;
            }
            output.logLevel = cookieLogLevel;
            output.on = !!cookieLogLevel;
            output.player = this.#debugCookie.debugPlayer;
            output.lowLevel = this.#debugCookie.debugLowLevel;
        }
        return output;
    }
}
